import styled from "@mui/material/styles/styled";
import { Box } from "@mui/material";

export const AuthLayoutContainer = styled(Box)(() => ({
  minHeight: "100vh",
  display: "flex",
  width: "100%",
}));

export const AuthLeftPanel = styled(Box)(({ theme }) => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  backgroundColor: theme.palette.background.secondary,
  alignItems: "center",
  position: "relative",
}));

export const AuthLogoContainer = styled(Box)(() => ({
  width: "100%",
  padding: "60px 0 0 60px",
  "& svg": {
    width: "207px",
    height: "44px",
  },
}));

export const AuthContentContainer = styled(Box)(() => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  padding: "0px 50px 60px 60px",
}));

interface AuthRightPanelProps {
  backgroundImage: string;
}

export const AuthRightPanel = styled(Box, {
  shouldForwardProp: (prop) => prop !== "backgroundImage",
})<AuthRightPanelProps>(({ backgroundImage }) => ({
  flex: 1,
  backgroundImage: `url(${backgroundImage})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  position: "relative",
}));
